<template lang='pug'>
.permit

	map-viewer.permit-map(
		:pin='permitLocation'
		:location='permitLocation'
		v-if='permit.location.lat && permit.location.lng'
	)

	p.title Permit
	h1.number # {{ permit.number }}

	.expand-info(@click='setExpandState')
		p Expand all Info
		.clickable-arrow(:class='expandState')

	.info
		list-layout(
			:layout='listItems'
			:parentObj='formattedPermit'
			:class='{ "slide-in" : expandState === "open" }'
		)
</template>

<script>
import MapViewer from '@/components/map/Viewer';
import ListLayout from '@/components/ListLayout';
// eslint-disable-next-line no-unused-vars
import { GetPermit } from '@/lib/API';
import Submit from '@/lib/Submit';
import { objectOrNull } from '@/lib/vue-validators';
import { editPermit } from '@/lib/generate';
// eslint-disable-next-line no-unused-vars
import { FormatDate } from '@/lib/utils';

export default {
	name : 'permit',

	props : {

		permit : {
			required  : true,
			validator : objectOrNull,
		},

	},

	data : () => ( {
		expandState : 'close',
	} ),

	computed : {

		formattedPermit() {

			let {
				permitFee,
				inspectionFee,
				materialsFee,
				shutdownFee,
				depositFee,
				depositDeductions
			} = this.permit;

			const addDollarSign = ( fee ) => {

				if ( !fee && fee !== 0 ) {
					return null;
				}

				if ( fee[0] === '$' ) {
					return fee;
				}

				return `$${fee}`;

			};

			permitFee         = addDollarSign( permitFee );
			inspectionFee     = addDollarSign( inspectionFee );
			materialsFee      = addDollarSign( materialsFee );
			shutdownFee       = addDollarSign( shutdownFee );
			depositFee        = addDollarSign( depositFee );
			depositDeductions = addDollarSign( depositDeductions );

			return {
				...this.permit,
				permitFee,
				inspectionFee,
				materialsFee,
				shutdownFee,
				depositFee,
				depositDeductions,
			};

		},

		listItems() {

			return {
				title : 'General Information',
				items : {
					permitsType : {
						items : {
							description : 'Permit Type',
						},
					},
					job : {
						parent : this.formattedPermit,
						items  : {
							number : 'Job/Misc. #',
						},
					},
					issuedBy  : 'Issued By',
					permittee : 'Permittee',
					facility  : {
						items : {
							name : 'Facility',
						},
					},
					status   : 'Status',
					summary  : 'Summary',
					location : {
						items : {
							description : 'Cross Streets',
						},
					},
					details : {
						title  : 'Details',
						parent : this.formattedPermit,
						items  : {
							wso : 'WSO Area',
							t   : 'T',
							r   : 'R',
							s   : 'Sec',
							q   : 'Q',
						},
					},
					dates : {
						title  : 'Dates',
						parent : this.formattedPermit,
						items  : {
							dateIssued          : 'Date Issued',
							dateStarted         : 'Start Date',
							dateFinished        : 'Finish Date',
							dateFinalInspection : 'Final Inspection Date',
							dateDepositReturned : 'Deposit Return Date',
							dateReminder        : 'Reminder Date',
						}
					},
					fees : {
						title  : 'Fees',
						parent : this.formattedPermit,
						items  : {
							permitFee         : 'Permit Fee',
							inspectionFee     : 'InspectionFee',
							materialsFee      : 'Material Fee',
							shutdownFee       : 'Shutdown Fee',
							depositFee        : 'Deposit Fee',
							depositDeductions : 'Deposit Deductions',
						},
					},
					comments  : 'Comments',
					driveLink : 'Drive Link',
				}
			};
		},

		permitLocation() {
			if ( !this.permit ) {
				return undefined;
			}

			if ( !this.permit.location ) {
				return undefined;
			}

			const { latitude, longitude } = this.permit.location;

			return {
				lat : latitude,
				lng : longitude,
			};
		},

	},

	methods : {

		setExpandState() {
			this.expandState = this.expandState === 'open' ? 'close' : 'open';
		},

		editPermit() {

			const changedPermit = editPermit( this.permit );

			Submit.editPermit( changedPermit, this.permit.key, 'Editing Permit Status...' );
		}

	},

	components : {
		MapViewer,
		ListLayout,
	}
};
</script>

<style lang='scss'>

.permit {
	display: flex;
	flex-flow: column;
	width: 100%;
	padding: 0px 30px;

	.viewer {
		width: 400px;
		height: 200px;
	}

	.title {
		width: 100%;
		font-size: 18px;
		font-weight: 500;
		margin-top: 15px;
	}

	.number {
		font-size: 24px;
		color: $input-color;
	}

	.expand-info {
		position: relative;
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
		width: fit-content;
		margin-left: 0;
		cursor: pointer;

		p {
			color: $alternateGrey;
			font-weight: 300;
			text-align: left;
		}

		.clickable-arrow {
			position: relative;
			left: 10px;

			&::before, &::after {
				background: $alternateGrey;
			}
		}
	}

	.info {

		.list-layout {

			.list-layout-dates {
				clear: left;
			}

			.item-permitsType {
				flex: 2 2 49%;
			}

			.list-layout-dates, .list-layout-details {
				flex: 0 0 100%;
			}

			.list-layout-job, .list-layout-facility {
				flex: 0 0 49%;
			}

			.list-layout-permitsType {
				flex: 0 0 49%;
			}

			.list-item-depositDeductions {

				&::before {
					content: '$',
				}
			}
		}
	}
}

</style>
